const tvMonitor = {
    'document_title': '即時監控',
    'to_fullscreen': '切換為全螢幕'
};

export default tvMonitor;
